import { TableCell, TableSortLabel } from "@mui/material";
import type { SxProps, Theme } from "@mui/material";
import type { ReactNode } from "react";
import type { SortDirection } from "./useSortAndFilter";

interface SortableHeaderCellProps<SortKey extends string> {
  sortKeyName: SortKey;
  activeSortKey: SortKey | null;
  direction: SortDirection;
  onSort: (key: SortKey) => void;
  children: ReactNode;
  align?: "left" | "center" | "right";
  sx?: SxProps<Theme>;
}

export default function SortableHeaderCell<SortKey extends string>({
  sortKeyName,
  activeSortKey,
  direction,
  onSort,
  children,
  align,
  sx,
}: SortableHeaderCellProps<SortKey>) {
  const active = activeSortKey === sortKeyName;

  return (
    <TableCell
      align={align}
      sx={sx}
      sortDirection={active ? direction : false}
    >
      <TableSortLabel
        active={active}
        direction={active ? direction : "asc"}
        onClick={() => onSort(sortKeyName)}
      >
        {children}
      </TableSortLabel>
    </TableCell>
  );
}
